/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const DefaultMessageType = {
    StartMatch: 'StartMatch',
    CloseMatch: 'CloseMatch',
    StartAtsMatch: 'StartAtsMatch',
    StartMatchWithPhoneContactPreference: 'StartMatchWithPhoneContactPreference'
};
export function instanceOfDefaultMessageType(value) {
    for (const key in DefaultMessageType) {
        if (Object.prototype.hasOwnProperty.call(DefaultMessageType, key)) {
            if (DefaultMessageType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function DefaultMessageTypeFromJSON(json) {
    return DefaultMessageTypeFromJSONTyped(json, false);
}
export function DefaultMessageTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function DefaultMessageTypeToJSON(value) {
    return value;
}
export function DefaultMessageTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
